/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { column, rem, row } from "../../ui";
import { ComponentContainerProps } from "./types";

export const div = ({
  size,
  sizes,
}: Pick<ComponentContainerProps, "size" | "sizes">) => {
  const getBySize = () => {
    if (size === "sm") {
      return `
        max-width: ${rem(sizes.sm)};
        padding-left: ${rem("md")};
        padding-right: ${rem("md")};
      `;
    } else if (size === "lg") {
      return `
        max-width: ${rem(sizes.lg)};
        padding-left: ${rem("xl")};
        padding-right: ${rem("xl")};
      `;
    } else {
      return `
        max-width: ${rem(sizes.md)};
      `;
    }
  };

  return css`
    width: 100%;
    ${column("md")}
    padding: ${rem("md")};
    ${getBySize()};
    margin: 0px auto;
  `;
};
